// const breakPoint = 767;
// let resizeFlag   = false;
// let windowWidth  = window.innerWidth;
// let windowHeight = window.innerHeight;
// let windowWidthJ = $(window).width();
let headerFlag = false;
let stHeader  = document.getElementById('st-Header');
let stHeaderNav  = document.getElementById('st-Header_Nav');
let headerButton  = document.getElementById('st-Menu');


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  //ページ外からのページ内リンク
  var urlHash = location.hash;
  if(urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
        var target = $(urlHash);
        var position = target.offset().top - 20;
        $('body,html').stop().animate({scrollTop:position}, 500);
    }, 200);
  }

  //ページ内リンク
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 600;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    // var heaaderH       = $("#st-Header").height();
    if(headerFlag){
      stHeader.classList.remove('opend');
      stHeader.classList.add('closed');
      stHeaderNav.classList.remove('opend');
      stHeaderNav.classList.add('closed');
      headerButton.classList.remove('opend');
      headerButton.classList.add('closed');
      headerFlag = false;
      setTimeout(function(){
        $('#st-Header_Nav').css({'display':'none'});
  		},200);
    }
    // else if($(this).hasClass('anchor')){
    //     stHeader.classList.remove('opend');
    //     stHeader.classList.add('closed');
    //     stHeaderNav.classList.remove('opend');
    //     stHeaderNav.classList.add('closed');
    //     headerButton.classList.remove('opend');
    //     headerButton.classList.add('closed');
    //     headerFlag = false;
    //     setTimeout(function(){
    //       $('#st-Header_Nav').css({'display':'none'});
    // 		},200);
    // }
    // if(windwW >= 768){
    //   if(linkHref === "#access"){
    //     linkAdjust += 80;
    //   }else if(linkHref === "#main"){
    //     linkAdjust += 80;
    //   }else if(linkHref === "#contact"){
    //     linkAdjust += 80;
    //   }else{
    //     linkAdjust += 0;
    //   }
    // }else{
    //   if(linkHref === "#access"){
    //     linkAdjust += heaaderH;
    //   }else if(linkHref === "#main"){
    //     linkAdjust += heaaderH;
    //   }else{
    //     linkAdjust += 30;
    //   }
    // }
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
  $(".anchor").on("click", function(){
    // var linkSpeed    = 500;
    // var linkHref     = $(this).attr("href");
    // var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    // var linkAdjust   = 0;
    // var linkPosition = linkHref.offset().top;a
    // var urlHash = location.hash;
    // if(urlHash) {
    //   // $('body,html').stop().scrollTop(0);
    //   var target = $(urlHash);
    //   var position = target.offset().top - 0;
    //   $('#system').stop().animate({scrollTop:position}, 500);
    // }
    if(headerFlag){
      stHeader.classList.remove('opend');
      stHeader.classList.add('closed');
      stHeaderNav.classList.remove('opend');
      stHeaderNav.classList.add('closed');
      headerButton.classList.remove('opend');
      headerButton.classList.add('closed');
      headerFlag = false;
      setTimeout(function(){
        $('#st-Header_Nav').css({'display':'none'});
  		},200);
    }
  });
  // $(".anchor2 a").on("click", function(){
  //   // var linkSpeed    = 500;
  //   // var linkHref     = $(this).attr("href");
  //   // var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
  //   // var linkAdjust   = 0;
  //   // var linkPosition = linkHref.offset().top;a
  //   var urlHash = location.hash;
  //   if(urlHash) {
  //     // $('body,html').stop().scrollTop(0);
  //     var target = $(urlHash);
  //     var position = target.offset().top - 0;
  //     $('#character').stop().animate({scrollTop:position}, 500);
  //   }
  //   if(headerFlag){
  //     stHeader.classList.remove('opend');
  //     stHeader.classList.add('closed');
  //     stHeaderNav.classList.remove('opend');
  //     stHeaderNav.classList.add('closed');
  //     headerButton.classList.remove('opend');
  //     headerButton.classList.add('closed');
  //     headerFlag = false;
  //     setTimeout(function(){
  //       $('#st-Header_Nav').css({'display':'none'});
  // 		},200);
  //   }
  // });
};

// ------------------------------------------------------------------------
// bnrSlide
// ----- BOTH
// ------------------------------------------------------------------------
const bnrSlide = () => {

var bnrSwiper;
  bnrSwiper = new Swiper('.index-Bnr-Box', {
    watchOverflow: true,
    // width: 500,
    slidesPerView: 2,
    // loopedSlides: 2,
    spaceBetween: 40,
    loop: true,
    grabCursor: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false // ユーザーのスワイプ操作を検出したら自動再生を中止するか
    },
    speed: 1000,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      hideOnClick: true,
    },
    breakpoints: {
      767: {
        // loop: !hasOneSlide,
        slidesPerView: 1
      }
    },
  });

};


// ------------------------------------------------------------------------
// howtoSlide
// ----- BOTH
// ------------------------------------------------------------------------
const howtoSlide = () => {

var howtoSwiper;
  howtoSwiper = new Swiper('.index-System_Howto-Box', {
    watchOverflow: false,
    // width: 1200,
    spaceBetween: 0,
    loop: true,
    grabCursor: true,
    centeredSlides: false,
    loopAdditionalSlides: 1,
    slidesPerView: 'auto',
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: false // ユーザーのスワイプ操作を検出したら自動再生を中止するかaaaa
    // },
    // speed: 1000,
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true
    // },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      hideOnClick: true,
    },
    breakpoints: {
      767: {
        // width:320,
        // loop: !hasOneSlide,
        // slidesPerView: 1
        // slidesPerView: 'auto'
      }
    },
  });

};


// ------------------------------------------------------------------------
// toggleHeader
// ----- BOTH
// ------------------------------------------------------------------------
const toggleHeader = () => {

  headerButton.addEventListener('click', () => {

    if(!headerFlag){
      $('#st-Header_Nav').css({'display':'block'});
      setTimeout(function(){
        stHeader.classList.remove('closed');
        stHeader.classList.add('opend');
        stHeaderNav.classList.remove('closed');
        stHeaderNav.classList.add('opend');
        headerButton.classList.remove('closed');
        headerButton.classList.add('opend');
        headerFlag = true;
  		},100);
    }else{
      stHeader.classList.remove('opend');
      stHeader.classList.add('closed');
      stHeaderNav.classList.remove('opend');
      stHeaderNav.classList.add('closed');
      headerButton.classList.remove('opend');
      headerButton.classList.add('closed');
      headerFlag = false;
      setTimeout(function(){
        $('#st-Header_Nav').css({'display':'none'});
  		},200);
    }
  }, false);


  // スクロールで縮める
  // $(window).on("scroll", function(){
  //   var scrollPosition = $(window).scrollTop();
  //     if(scrollPosition >= 50){
  //       $("#st-Header").addClass('st-Header-Shorten');
  //     } else {
  //       $("#st-Header").removeClass('st-Header-Shorten');
  //     }
  // });

};

// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const pageTop = () => {


  $(window).on("scroll", function(){
    var scrollPosition = $(window).scrollTop();
    // if(windowW >= 768){
      if(scrollPosition >= 50){
        $("#st-Top").removeClass('st-Top-Hidden');
      } else {
        $("#st-Top").addClass('st-Top-Hidden');
      }
    // }
  });

  $("#st-Top,#footer-top").on("click", function(){
    var linkSpeed    = 500;
    $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutQuint");
    return false;
  });

};


// ------------------------------------------------------------------------
// showMovie
// ----- BOTH
// ------------------------------------------------------------------------
const showMovie = () => {
  const $modal = $('#movie-Stage');
  const $content = $('#movie-Iframe');

  // open
  $('.js-Youtube').on('click', function(){
    // console.log('AAA');

    const dataID = $(this).attr('data-youtube');

    $('#movie-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},300,'easeOutQuart',function(){


      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;

  	});


  });
  //close
  $('#movie-Close,#movie-Iframe').on('click', function(){

    $('#movie-Stage').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){
      $('#movie-Stage').css({'display':'none'});
      $content.children('iframe').remove();
		});
    //
    // $modal.stop().fadeOut(300, function(){
    //   $content.children('iframe').remove();
    // });
  });

};



// ------------------------------------------------------------------------
// activeSubmit
// ----- BOTH
// ------------------------------------------------------------------------
const activeSubmit = () => {
  let formCheckbox = document.getElementById('con-Form_Accept');
  let formSubmit   = document.getElementById('con-Form_Submit');
  window.addEventListener('load', () => {
    let formWave = document.getElementById('con-Form_Wave');
    formCheckbox.addEventListener('change', () => {
      if(formCheckbox.checked){
        formSubmit.classList.add('con-Form_Submit-Active');
        formWave.classList.add('con-Form_Wave-Active');
      } else {
        formSubmit.classList.remove('con-Form_Submit-Active');
        formWave.classList.remove('con-Form_Wave-Active');
      }
    }, false);
  });
};


// ------------------------------------------------------------------------
// menuCurrentImage
// ----- BOTH
// ------------------------------------------------------------------------

const menuCurrentImage = () => {
  $(function() {
    if ($('.st-Header_Nav_List li').hasClass('current')) {
       $(".st-Header_Nav_List li.current a img").attr("src",$(".st-Header_Nav_List li.current a img").attr("src").replace(/^(.+)_off(\.[^\.]+)$/,"$1_on$2"));
    }
    // if ($('.st-Header_Nav_List li').hasClass('current')) {
    //    $(".st-Header_Nav_List li.current a img").attr("src",$(".st-Header_Nav_List li.current a img").attr("src").replace(/^(.+).png(\.[^\.]+)$/,"$1_on.png$2"));
    // }
  });
};
// document.addEventListener( 'wpcf7mailsent', function( event ) {
//   location = 'https://runnerz.bushimo.jp/contact';
// }, false );



// ------------------------------------------------------------------------
// loadContents
// ----- BOTH
// ------------------------------------------------------------------------
const loadContents = () => {
 // let loadContents     = document.querySelector('.idx-Load');
 let cloud     = document.querySelector('.cloud');
 let character     = document.querySelector('.character');
 // let balloon03     = document.querySelector('.balloon-03');
 // let campaignContents = document.querySelector('.idx-Campaign');

 window.addEventListener('load', () => {
   setTimeout(() => {
     cloud.classList.add('loaded');
   }, 1);
   setTimeout(() => {
     character.classList.add('loaded');
   }, 800);
   // setTimeout(() => {
   //   loadContents.parentNode.removeChild(loadContents);
   // }, 2000);
 });

}


// ------------------------------------------------------------------------
// animateFadea
// ----- BOTH
// ------------------------------------------------------------------------
const jsAnimation = () => {

 $(window).on('scroll', function(){
   $('js-Animation').each(function(){
     var imagePosition = $(this).offset().top;
     var scrollVolume  = $(window).scrollTop();
     var windowWidth   = $(window).width();
     var windowHeight  = $(window).height();
     if(windowWidth > breakPointSP){
       if(scrollVolume > imagePosition - windowHeight + windowHeight / 3.25){
         $(this).addClass('animated');
       }
     } else {
       if(scrollVolume > imagePosition - windowHeight + windowHeight / 4){
         $(this).addClass('animated');
       }
     }
   })
 });

 // $(window).load(function (){
 //   $('.js-Animation').each(function(){
 //     var imagePosition = $(this).offset().top;
 //     var scrollVolume  = $(window).scrollTop();
 //     var windowWidth   = $(window).width();
 //     var windowHeight  = $(window).height();
 //     if(windowWidth > breakPointSP){
 //       if(scrollVolume > imagePosition - windowHeight + windowHeight / 3.25){
 //         $(this).addClass('animated');
 //       }
 //     } else {
 //       if(scrollVolume > imagePosition - windowHeight + windowHeight / 4){
 //         $(this).addClass('animated');
 //       }
 //     }
 //   })
 // });

}

export {
  anchorLink,
  bnrSlide,
  howtoSlide,
  toggleHeader,
  pageTop,
  showMovie,
  activeSubmit,
  menuCurrentImage,
  jsAnimation,
  loadContents,
}



// WEBPACK FOOTER //
// ./src/runnerz/assets/js/include/module.js